import type { SVGProps } from 'react';

export const PausedNotificationLink = (props: SVGProps<SVGSVGElement>) => (
  <svg
    height="18px"
    version="1.1"
    viewBox="0 0 18 18"
    width="18px"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    {...props}
  >
    <title>{'waitlist notifications paused icon'}</title>
    <g fill="none" fillRule="evenodd" stroke="none" strokeWidth="1">
      <g transform="translate(-1131, -350)">
        <g transform="translate(1107, 326)">
          <g transform="translate(24, 24)">
            <rect height="18" width="18" x="0" y="0"></rect>
            <g transform="translate(2.8955, 3.0802)">
              <path
                d="M9.95337632,0 C10.88637,0 11.6427108,0.785860678 11.6427108,1.75526895 L11.6080341,6.70713539 L11.6427108,6.70713539 C11.5815551,7.2152707 10.2311708,5.39864613 7.34433288,8.62521608 C6.82128468,9.20981822 6.77011485,11.3880806 7.34433288,12.6776194 C7.75289946,13.5951496 9.10378684,14.0421516 8.95593141,14.0421516 L1.68933451,14.0421516 C0.756340824,14.0421516 0,13.2562909 0,12.2868827 L0,5.54286808 C0,5.45382301 2.49729235,6.77224407 3.57737958,6.1171123 C7.7671754,3.57577278 5.7847814,0 5.82135542,0 L9.95337632,0 Z M9.82045431,0.801036096 L6.1391522,0.801036096 C5.99303481,2.38119343 5.61631326,4.28336876 4.46875667,5.09753642 C3.09621553,6.07132596 0.929476857,5.8214448 0.929476857,6.1260809 L0.929476857,12.1632673 C0.929476857,12.7226041 1.35604766,13.1760361 1.88224941,13.1760361 L7.75072709,13.1760361 C8.23233247,13.1760361 6.65018463,11.2021653 7.31428094,8.6902634 C8.25745155,7.65457439 9.03687492,6.94810846 9.65255105,6.5708656 C9.80552956,6.47713117 10.1790882,6.47713117 10.7732269,6.5708656 L10.7732269,1.81380491 C10.7732269,1.29442077 10.4054184,0.866352433 9.93156771,0.807849733 L9.82045431,0.801036096 Z"
                fill="#3D57FF"
                fillRule="nonzero"
              ></path>
              <g
                stroke="#3D57FF"
                strokeLinecap="round"
                strokeWidth="0.84375"
                transform="translate(2.5129, 4.2933)"
              >
                <g transform="translate(2.7821, 0)">
                  <line x1="0" x2="3.65183269" y1="0.28125" y2="0.28125"></line>
                </g>
                <g transform="translate(0, 2.8125)">
                  <line
                    x1="1.86909494"
                    x2="5.75034494"
                    y1="0.28125"
                    y2="0.28125"
                  ></line>
                  <line
                    x1="0.1153125"
                    x2="0.4471875"
                    y1="0.282117776"
                    y2="0.282117776"
                  ></line>
                </g>
                <g transform="translate(0, 5.44)">
                  <line
                    x1="1.86909494"
                    x2="4.42537766"
                    y1="0.466243316"
                    y2="0.466243316"
                  ></line>
                  <line
                    x1="0.1153125"
                    x2="0.4471875"
                    y1="0.467111092"
                    y2="0.467111092"
                  ></line>
                </g>
              </g>
              <ellipse
                cx="10.8787272"
                cy="10.5316137"
                rx="3.80387462"
                ry="3.96629738"
                stroke="#3D57FF"
                strokeWidth="0.84375"
              ></ellipse>
              <path
                d="M10.3952775,11.2803733 L10.3952775,10.8854083 L10.3952775,8.68625443 C10.3952775,8.49365788 10.5514079,8.33752752 10.7440044,8.33752752 C10.936601,8.33752752 11.0927314,8.49365788 11.0927314,8.68625443 L11.0927314,11.1930912 C11.0927314,11.3155897 10.9934267,11.4148944 10.8709281,11.4148944 C10.8600263,11.4148944 10.8491393,11.4140907 10.8383557,11.4124897 L10.6773085,11.3885803 C10.6151741,11.3793557 10.5524442,11.3747245 10.4896288,11.3747245 C10.43752,11.3747245 10.3952775,11.332482 10.3952775,11.2803733 Z"
                fill="#3D57FF"
                fillRule="nonzero"
              ></path>
              <path
                d="M11.3899588,10.1267001 C11.4468683,10.1166654 11.5054709,10.1283806 11.5541488,10.1595232 L11.7659536,10.2950294 C11.9430164,10.4083086 12.0435446,10.6096919 12.0276583,10.8192892 L11.9291472,12.1190001 C11.9128996,12.3333626 11.7307284,12.496915 11.5158608,12.4900465 C11.312108,12.4835332 11.1522137,12.3130789 11.158727,12.1093261 C11.1588868,12.1043286 11.159148,12.0993348 11.1595107,12.094348 L11.2949461,10.231928 C11.2987782,10.1792308 11.3379251,10.135875 11.3899588,10.1267001 Z"
                fill="#3D57FF"
                transform="translate(11.5925, 11.3067) scale(-1, -1) rotate(100) translate(-11.5925, -11.3067)"
              ></path>
            </g>
            <g fillRule="nonzero" transform="translate(0.5625, 0.5625)">
              <path
                d="M4.22699607,0 C1.89268481,0 0,1.93317005 0,4.3174131 C0,6.70165616 1.89268481,8.6348262 4.22699607,8.6348262 C6.56130734,8.6348262 8.45399215,6.70165616 8.45399215,4.3174131 C8.45399215,1.93317005 6.56130734,0 4.22699607,0 Z"
                stroke="#E66A00"
                strokeWidth="1.125"
              ></path>
              <path
                d="M2.615625,5.86016042 L2.615625,2.90521391 C2.615625,2.69120357 2.78911466,2.5177139 3.00312501,2.5177139 L3.30343361,2.5177139 C3.51744395,2.5177139 3.69093361,2.69120357 3.69093361,2.90521391 L3.69093361,5.86016042 C3.69093361,6.07417077 3.51744395,6.24766043 3.30343361,6.24766043 L3.00312501,6.24766043 C2.78911466,6.24766043 2.615625,6.07417077 2.615625,5.86016042 Z M4.61221875,5.86016042 L4.61221875,2.90521391 C4.61221875,2.69120357 4.78570841,2.5177139 4.99971876,2.5177139 L5.30002736,2.5177139 C5.5140377,2.5177139 5.68752736,2.69120357 5.68752736,2.90521391 L5.68752736,5.86016042 C5.68752736,6.07417077 5.5140377,6.24766043 5.30002736,6.24766043 L4.99971876,6.24766043 C4.78570841,6.24766043 4.61221875,6.07417077 4.61221875,5.86016042 Z"
                fill="#E66A00"
              ></path>
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
);
